<template>
  <div class="filter-bar">
    <ui-field-input
      :label="$t('compliance_reviews.search.search')"
      :placeholder="$t('compliance_reviews.search.search')"
      label-position="top"
      v-model="filterByText"
      class="filter-field-wide"
      id="filter-by-text"
      type="search"
    />
    <ui-field-select
      :label="$t('compliance_reviews.search.searchBy')"
      :id="'status'"
      :options="searchByOptions"
      :disabled="complianceReviewListLoading"
      class="filter-field"
      type="text"
      v-model="searchByOption"
    />
    <date-picker-field
      :compliance-review-date-range.sync="complianceReviewDateRange"
    />
    <ui-field-select
      :label="$t('compliance_reviews.search.status')"
      :id="'status'"
      :options="complianceReviewStatusOptions"
      :disabled="complianceReviewListLoading"
      :error="complianceReviewStatusRequiredError"
      required
      class="filter-field"
      type="text"
      v-model="complianceReviewStatus"
    />
    <div v-if="complianceReviewStatusRequiredError" class="error-text">
      {{ complianceReviewStatusRequiredError }}
    </div>
    <ui-button variant="primary" class="search-button" @click="handleSearch">
      {{ $t("compliance_reviews.search.search") }}
    </ui-button>
  </div>
</template>

<script>
import {
  COMPLIANCE_REVIEW_STATUS,
  FILTER_OPTIONS
} from "@/constants/complianceReview";
import DatePickerField from "./DatePickerField.vue";

export default {
  components: { DatePickerField },
  props: {
    complianceReviewListLoading: { type: Boolean, default: false },
    handleGetComplianceReviewList: { type: Function, default: null }
  },

  data() {
    return {
      filterByText: this.$route.query.kycIdentificationId || "",
      searchByOption: FILTER_OPTIONS.IDENT_ID,
      complianceReviewStatus:
        this.$route.query.status || COMPLIANCE_REVIEW_STATUS.PENDING,
      complianceReviewStatusRequiredError: null,
      complianceReviewDateRange:
        this.$route.query.createdUtcFrom && this.$route.query.createdUtcTo
          ? [
              new Date(this.$route.query.createdUtcFrom),
              new Date(this.$route.query.createdUtcTo)
            ]
          : null
    };
  },

  computed: {
    complianceReviewStatusOptions() {
      return [
        {
          label: this.$t("compliance_reviews.search.pending"),
          value: COMPLIANCE_REVIEW_STATUS.PENDING
        },
        {
          label: this.$t("compliance_reviews.search.completed"),
          value: COMPLIANCE_REVIEW_STATUS.COMPLETED
        }
      ];
    },

    searchByOptions() {
      return [
        // TODO: add companyName and projectName once BE is done
        // {
        //   label: this.$t("compliance_reviews.search.companyName"),
        //   value: FILTER_OPTIONS.COMPANY_NAME
        // },
        // {
        //   label: this.$t("compliance_reviews.search.projectName"),
        //   value: FILTER_OPTIONS.PROJECT_NAME
        // },
        {
          label: this.$t("compliance_reviews.search.identId"),
          value: FILTER_OPTIONS.IDENT_ID
        }
      ];
    },

    createdUtcFilter() {
      const dateFrom = this.complianceReviewDateRange?.[0];
      const dateTo = this.complianceReviewDateRange?.[1];

      if (!dateFrom || !dateTo) {
        return undefined;
      }

      return {
        from: this.complianceReviewDateRange?.[0],
        to: this.complianceReviewDateRange?.[1]
      };
    },

    identIdFilter() {
      if (
        this.searchByOption !== FILTER_OPTIONS.IDENT_ID ||
        !this.filterByText?.length
      ) {
        return undefined;
      }

      return this.filterByText;
    },

    filterPayload() {
      return {
        status: this.complianceReviewStatus,
        createdUtc: this.createdUtcFilter,
        kycIdentificationId: this.identIdFilter
        // TODO: add companyName and projectName once BE is done
      };
    }
  },

  methods: {
    handleSearch() {
      if (!this.complianceReviewStatus) {
        this.complianceReviewStatusRequiredError = this.$t(
          "compliance_reviews.search.status_required"
        );

        return;
      }

      this.complianceReviewStatusRequiredError = null;
      this.handleGetComplianceReviewList(this.filterPayload);

      this.$router.replace({
        query: {
          status: this.filterPayload.status,
          kycIdentificationId: this.filterPayload.kycIdentificationId,
          createdUtcFrom: this.filterPayload.createdUtc?.from,
          createdUtcTo: this.filterPayload.createdUtc?.to
        }
      });

      return;
    }
  },

  mounted() {
    this.handleGetComplianceReviewList(this.filterPayload);
  }
};
</script>

<style scoped>
.filter-bar {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 1rem;
}

.error-text {
  color: var(--red);
}

.filter-bar .search-button {
  margin-top: 0.75rem;
}

.filter-field {
  min-width: 7rem;
}

.filter-field-wide {
  min-width: 15rem;
}
</style>
